jQuery(document).ready(function() {
    // Fonction pour mettre à jour le style du menu
    function updateMenuAncres() {
        var sections = jQuery('.toolbox-ancre-card');
        var menuItems = jQuery('.ancres a');
        sections.each(function(index, section) {
            var rect = section.getBoundingClientRect();
            if (rect.top <= 10 && rect.bottom >= 70) {
                menuItems.removeClass('active');
                menuItems.eq(index).addClass('active');
            }
        });
    }

    // Fonction pour gérer le clic sur les liens du menu
    function handleClick(event) {
        event.preventDefault();
        var targetId = jQuery(this).attr('href').split('#')[1];
        // section correspondante
        var targetSection = jQuery('#' + targetId);
        if (targetSection.length > 0) {
            jQuery('html, body').animate({
                scrollTop: targetSection.offset().top
            }, 'slow');
        }
        updateMenuAncres(); // Mettre à jour le menu après le clic
    }

    // Ajouter un gestionnaire d'événements pour chaque lien du menu
    jQuery('.ancres a').on('click', handleClick);

    // Écouter l'événement de défilement de la page
    jQuery(window).on('scroll', updateMenuAncres);

    // Appeler la fonction au chargement initial de la page
    updateMenuAncres();
});